// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatas } from "../../../icons/full/build/icon-statas.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatasIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatas.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatasIcon.displayName = 'StatasIcon';
}

export default StatasIcon;